var exports = {
  "qd": "FloatingUnreadIndicators.module__layer___cTdTRX",
  "NI": "FloatingUnreadIndicators.module__slot___cTdTRX",
  "AH": "FloatingUnreadIndicators.module__slotTop___cTdTRX",
  "Y0": "FloatingUnreadIndicators.module__slotBottom___cTdTRX",
  "q3": "FloatingUnreadIndicators.module__indicator___cTdTRX",
  "lL": "FloatingUnreadIndicators.module__indicatorBrand___cTdTRX",
  "Gi": "FloatingUnreadIndicators.module__indicatorMention___cTdTRX",
};

module.exports = exports;
